const NODE_ENV = process.env.NODE_ENV
const baseURL= NODE_ENV == "development" ? "https://api.hexfuture.net" : "/routeapi";
export default baseURL;